// ⚠️ DO NOT add <script type="application/ld+json"> in Helmet.
// All JSON-LD schema is in static prerendered HTML only.
// Duplicating it causes Google to reject rich results.

import { Helmet } from "react-helmet-async";
import { SITE_URL } from "@/lib/seo-constants";

const PillPageSEO = () => {
  return (
    <Helmet>
      <title>Order the Contraceptive Pill Online, Free on the NHS | Contraception Direct</title>
      <meta name="description" content="Order the contraceptive pill online free on the NHS. A pharmacist checks your suitability by phone, no GP appointment and no prescription charge, with discreet UK-wide delivery in 1 to 3 working days." />
      <meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />
      <link rel="canonical" href={`${SITE_URL}/get-the-pill-online/`} />
      <link rel="alternate" hrefLang="en-gb" href={`${SITE_URL}/get-the-pill-online/`} />
      <link rel="alternate" hrefLang="x-default" href={`${SITE_URL}/get-the-pill-online/`} />
      <meta name="geo.region" content="GB" />
      <meta name="geo.placename" content="United Kingdom" />

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content="Order the Contraceptive Pill Online, Free on the NHS" />
      <meta property="og:description" content="No GP appointment needed. Book a phone consultation and get your pill delivered free in 1-3 working days through the NHS Pharmacy Contraception Service." />
      <meta property="og:url" content={`${SITE_URL}/get-the-pill-online/`} />
      <meta property="og:site_name" content="Contraception Direct" />
      <meta property="og:locale" content="en_GB" />
      <meta property="og:image" content={`${SITE_URL}/og-image.png`} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:alt" content="Contraception Direct. Free NHS contraceptive pill delivery service" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="Get the Contraceptive Pill Online | Free NHS Service" />
      <meta name="twitter:description" content="No GP appointment needed. Book a phone consultation and get your pill delivered free in 1-3 working days." />
      <meta name="twitter:image" content={`${SITE_URL}/og-image.png`} />
    </Helmet>
  );
};

export default PillPageSEO;
